import * as React from "react";

import { confirmDialog } from "primereact/confirmdialog";
import { cn, Component } from "../../helpers/Utils";

export interface IFileProps {
	value?: string;
	id: string;
	onChange: (id: string, e: React.ChangeEvent<HTMLInputElement>) => void;
	url: string;
	disabled?: boolean;
	isBase64?: boolean;
	isLoader: boolean;
	api?: Record<string, unknown>;
	schema?: {
		extra?: {
			accept?: string,
			[key: string]: unknown
		}
	}
}

interface IState {
	isClicked: boolean;
}

interface FileIconProps {
	value: string;
	url: string;
	checkIsAuth?: (event: React.MouseEvent<HTMLElement>) => void;
	isBase64?: boolean;
	isClicked?: boolean;
}

function FileIcon({ url, value, checkIsAuth, isBase64, isClicked }: FileIconProps): JSX.Element {
	const nameIcon = value?.split(".")?.pop()?.toLowerCase() || "unknown";

	return (
		<span
			className={cn("input-group--file", {
				wait: !!isClicked,
			})}
			style={{ width: "1%", flex: "1 0 auto" }}
		>
			<div className="form-control form-control--file">
				<label className="file-load">
					{
						isBase64 ? <a download={value} href={url} target="__blank">
							<span className="row valign">
								<span className={`fileicon fileicon-${nameIcon}`} />
								<span className="control-label control-label--file" title={value}>
									{isClicked ? "Скачивается" : value}
								</span>
							</span>
						</a> : <a download href={url} target="__blank" onClick={checkIsAuth}>
							<span className="row valign">
								<span className={`fileicon fileicon-${nameIcon}`} />
								<span className="control-label control-label--file" title={value}>
									{isClicked ? "Скачивается" : value}
								</span>
							</span>
						</a>
					}
				</label>
			</div>
		</span>
	);
}

export class File extends Component<IFileProps, IState> {
	state = {
		isClicked: false,
	};

	confirm = (msg?: string) => {
		confirmDialog({
			message: msg ?? "API недоступно",
			header: "Ошибка",
			accept: null,
			reject: null,
			acceptLabel: "Ок",
			rejectLabel: " ",
		});
	};

	checkIsAuth = (event?: React.MouseEvent<HTMLElement>) => {
		event.preventDefault();
		const { api, id } = this.props;
		this.setState({ isClicked: true });

		fetch(`${api.filesUrl}${id}/document`)
			.then((res) => {
				if (!res.ok) {
					throw new Error("API недоступно");
				}

				return res.blob();
			})
			.then((data) => {
				const _a = document.createElement("a");
				_a.href = window.URL.createObjectURL(data);
				_a.download = this.props?.value ?? id;

				_a.click();
			})
			.catch((error) => {
				this.confirm(error?.message);
			})
			.finally(() => {
				this.setState({ isClicked: false });
			});

	};

	render() {
		const { schema, isLoader, value, disabled, onChange, id, url, isBase64 } = this.props;
		const { isClicked } = this.state;

		const accepts = schema?.extra?.accept ?? ""

		return value === null || isLoader ? (
			<div className="form-control">
				{!isLoader ? (
					<label className="file-load">
						<input
							disabled={disabled}
							className="file-load__input"
							type="file"
							accept={accepts}
							onChange={(event) => onChange(id, event)}
						/>
						<button type="button" className="file-load__button">
							Выбрать файлы
						</button>
					</label>
				) : (
					<span key={2} className="control-label control-label--file">
						Файл сохраняется...
					</span>
				)}
			</div>
		) : (
			<FileIcon url={url} value={value} checkIsAuth={this.checkIsAuth} isBase64={isBase64} isClicked={isClicked} />
		);
	}
}
